

export const loadCurrentFontSize = (s: number, m: number, l: number, fontSize: number) => {
    if(fontSize == 0) return `text-[${s}px]`;
    else if(fontSize == 1) return `text-[${m}px]`;
    else if(fontSize == 2) return `text-[${l}px]`;
}